import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModeleTheme } from '../../../constantes/publipostage/modele-theme';
import { SourceDemandePublipostage } from '../../../constantes/publipostage/source-demande-publipostage';
import { MediaPublipostage } from '../../../constantes/publipostage/type-modele';
import { PublipostageModeleView } from '../../../models/publipostage-modele/publipostage-modele';
import { ThemesFilter } from '../../../models/publipostage-modele/themes-by-source-modele';
import { PublipostageModelesService } from '../../../services/publipostage-modeles/publipostage-modeles.service';
import { ModeleUtils } from '../../../utils/modele-utils';

export class PublipostageConfig {
  constructor(public idModele: number, public type: MediaPublipostage, public theme: ModeleTheme) {}
}

@Component({
  selector: 'selecteur-modele-publipostage',
  templateUrl: './selecteur-modele-publipostage.component.html',
  styleUrls: ['./selecteur-modele-publipostage.component.scss'],
})
export class SelecteurModelePublipostageComponent implements OnDestroy, OnInit {
  private _source: SourceDemandePublipostage;
  type: MediaPublipostage;
  selectedTheme: ModeleTheme;
  _themesFilter: ThemesFilter;
  themesAffiches: ModeleTheme[];
  modeles: PublipostageModeleView[] = [];
  selectedModele: PublipostageModeleView;
  isTypeMail = false;

  @Input() set themeFilter(value: ThemesFilter) {
    this._themesFilter = value;
  }

  @Input() set source(value: SourceDemandePublipostage) {
    this._source = value;
  }

  @Output() publipost = new EventEmitter<PublipostageConfig>();

  get themeFilter(): ThemesFilter {
    return this._themesFilter;
  }

  get source(): SourceDemandePublipostage {
    return this._source;
  }

  private subscriptions: Array<Subscription> = [];

  @Output() close = new EventEmitter();

  constructor(private publipostageModelesService: PublipostageModelesService) {}

  ngOnInit() {
    this.selectDefaultTheme();
  }

  private applyThemeFilter(type: MediaPublipostage) {
    if (this._themesFilter != null) {
      if (type == MediaPublipostage.Courrier) {
        this.themesAffiches = this._themesFilter.Courrier.slice();
      } else {
        this.themesAffiches = this._themesFilter.Mail.slice();
      }
      if (this.themesAffiches.findIndex(ele => ele == this.selectedTheme) == -1) {
        this.selectedTheme = null;
        this.selectedModele = null;
        this.modeles = null;
      }
    }
  }

  loadModelesByTheme() {
    if (this.selectedTheme != null) {
      this.subscriptions.push(
        this.publipostageModelesService
          .getModelesByTheme(this.type, this.selectedTheme)
          .subscribe(modeles => (this.modeles = modeles)),
      );
    }
  }

  isNothingSelected() {
    return this.selectedModele == null;
  }

  publiposter() {
    if (this.selectedModele != null) {
      this.publipost.emit(new PublipostageConfig(this.selectedModele.id, this.type, this.selectedTheme));
      this.fermer();
    }
  }

  fermer() {
    this.close.next();
  }

  cancel() {
    this.selectedModele = null;
    this.fermer();
  }

  selectionnerModele(selectedModele: PublipostageModeleView) {
    this.selectedModele = selectedModele;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  switchToCourrier() {
    this.type = MediaPublipostage.Courrier;
    this.selectedModele = null;
    this.applyThemeFilter(this.type);
    this.loadModelesByTheme();
    this.isTypeMail = false;
  }

  switchToMail() {
    this.type = MediaPublipostage.Email;
    this.selectedModele = null;
    this.applyThemeFilter(this.type);
    this.loadModelesByTheme();
    this.isTypeMail = true;
  }

  selectTheme(themeModele: ModeleTheme) {
    this.selectedTheme = themeModele;
    this.selectedModele = null;
    this.loadModelesByTheme();
  }

  getLibelleTheme(themeModele: ModeleTheme): string {
    return ModeleUtils.getLibelleTheme(themeModele);
  }

  getLibelleAction(type: MediaPublipostage): string {
    if (type == MediaPublipostage.Courrier) {
      return 'Générer';
    } else {
      return 'Envoyer';
    }
  }

  private selectDefaultTheme() {
    let defautTheme: ModeleTheme = null;
    if (this._themesFilter.Mail.length > 0)
    {
      defautTheme = this._themesFilter.Mail[0];
      this.switchToMail();
      this.selectTheme(defautTheme);
    }
    else if (this._themesFilter.Courrier.length > 0)
    {
      defautTheme = this._themesFilter.Courrier[0];
      this.switchToCourrier();
      this.selectTheme(defautTheme);
    }
  }
}
